// extracted by mini-css-extract-plugin
export var sliderRange = "_c9-2";
export var sliderRoot = "_c9-0";
export var sliderThumb = "_c9-3";
export var sliderTrack = "_c9-1";